module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.template) ? _c('document-container', {
    attrs: {
      "body": _vm.template.body(),
      "footer": _vm.template.footer(),
      "header": _vm.template.header(),
      "logo": _vm.logo,
      "tables": _vm.flatTableGroups,
      "documentType": "shortlist",
      "orientation": "landscape"
    }
  }, [(_vm.environment === 'blsk') ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "textblock disclaimer-emphasis"
  }, [_vm._v("\n      Nur zum internen Gebrauch | " + _vm._s(_vm.time) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'SCHREIBTISCH') ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', {
    staticClass: "textblock disclaimer-emphasis",
    staticStyle: {
      "color": "red",
      "font-style": "italic"
    }
  }, [_vm._v("\n\n      Bitte beachten: Individualkundenberatende II alle Produkte freigegeben, deren ein Index als Basiswert zugrundeliegt (außer Nachkaufzertifikate)”\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.mode === 'SCHREIBTISCH') ? _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-footer"
    },
    slot: "raw-footer"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Stadtsparkasse Düsseldorf - " + _vm._s(_vm.time) + " ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.template.body().filter(function (block) { return block.sort === undefined || (block.sort < 100); })), function(block) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c(block.type, {
      tag: "component",
      attrs: {
        "data": block
      }
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.tableGroups), function(tableGroup, groupKey) {
    return _vm._l((tableGroup.tables), function(table, tableKey) {
      return _c('div', {
        staticClass: "page-block",
        attrs: {
          "slot": "raw-body"
        },
        slot: "raw-body"
      }, [_c('TableShortlistProducts', {
        attrs: {
          "id": groupKey + ':' + table.title,
          "group-title": tableKey === 0 ? _vm.labels[groupKey] : null,
          "show-time": false,
          "table": table
        }
      })], 1)
    })
  }), _vm._v(" "), _vm._l((_vm.template.body().filter(function (block) { return block.sort >= 100; })), function(block) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c(block.type, {
      tag: "component",
      attrs: {
        "data": block
      }
    })], 1)
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34509a0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shortlist/Shortlist.vue
// module id = 672
// module chunks = 0